import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/proceso/getProcesos.php';

export default function getProcesos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}